export const colors = {
  primary: '#fafafa',
  secondary: '#424242',
  secondaryRgba: 'rgba(66,66,66,0.8)',
  background: '#222',
  blue: '#50d0f6',
}
